<template>
  <div class="box">
    <div class="searchBox">
      <div class="search">
        <img src="../assets/search.png" alt />
        <input type="text" id="searchShop" placeholder="输入店铺名称" />
      </div>
      <div class="clickSearch" v-on:click="SearchShop">搜索</div>
    </div>
    <baidu-map
      id="Map"
      class="bm-view"
      ak="QGGvEs2B684koGNEfUirzuoWUMzirbaQ"
      :center="center"
      :zoom="zoom"
      @ready="header"
      @dragend="draggingaaa"
    >
      <bml-marker-clusterer :averageCenter="true">
        <!-- <bm-marker
          :dragging="dragging"
          @dragend="dragend"
          v-if="!process"
          :position="People"
          animation="BMAP_ANIMATION_BOUNCE"
          :icon="{url: centerIMG, size: { width: 40, height:50} ,}"
        ></bm-marker>-->
        <div v-for="(item,index) in shopTypeList" :key="index">
          <bm-marker
            animation="BMAP_ANIMATION_BOUNCE"
            :position="{ lng: item.longitude, lat: item.latitude }"
            @click="infoWindowOpen(item)"
          ></bm-marker>
        </div>
      </bml-marker-clusterer>
      <bm-driving
        :start="startLocation"
        :end="endLocation"
        :auto-viewport="true"
        :panel="false"
        @markersset="markersset"
      ></bm-driving>
      <bm-control>
        <div class="btn" @click="toggle" v-if="process">返回</div>
      </bm-control>
      
    </baidu-map>
    <div class="locationImg" @click="tolocation">
        <img :src="toLocation" alt />
      </div>
      <div class="moveCenter" v-if="moveCenterShow">
        <img :src="moveCenter" alt />
      </div>
    <Nav tabindex="2"></Nav>
  </div>
</template>

<script>
import { BmlMarkerClusterer } from "vue-baidu-map";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow.vue";
import bmDriving from "vue-baidu-map/components/search/Driving.vue";
import bmControl from "vue-baidu-map/components/controls/Control.vue";
import $ from "jquery";
import Nav from "../components/Nav";
export default {
  name: "",
  data() {
    return {
      moveCenterShow: true,
      dragging: true,
      shopTypeList: [],
      ShopClassList: [],
      shopTypeName: "",
      zoom: 16,
      show: false,
      center: { lng: this.$store.state.log, lat: this.$store.state.lat },
      People: { lng: this.$store.state.log, lat: this.$store.state.lat },
      startLocation: { lng: this.$store.state.log, lat: this.$store.state.lat },
      endLocation: { lng: "", lat: "" },
      initialize: { lng: this.$store.state.log, lat: this.$store.state.lat }, //初始化位置
      positionList: [],
      a: false,
      tabList: [1, 0, 0],
      closeOnClick: false,
      centerIMG: require("../assets/fox.gif"),
      centerIMG2: require("../assets/allot2.png"),
      toLocation: require("../assets/toLocation.png"),
      moveCenter: require("../assets/moveCenter.png"),
      tabImg: [
        {
          showNow: require("../assets/index01.png"),
          showNo: require("../assets/index02.png"),
        },
        {
          showNow: require("../assets/map01.png"),
          showNo: require("../assets/map02.png"),
        },
        {
          showNow: require("../assets/us01.png"),
          showNo: require("../assets/us02.png"),
        },
      ],
      process: false,
    };
  },
  components: {
    Nav,
    BaiduMap,
    BmMarker,
    BmInfoWindow,
    BmlMarkerClusterer,
    bmDriving,
    bmControl,
  },
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo,
    });
    this.$store.commit(
      "UserSelf",
      JSON.parse(localStorage.getItem("ZQUserSelf"))
    );
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    $("#Map>div").css({
      height: "100%",
    });
  },
  activated() {},
  methods: {
    markersset(e) {
      e.map((item) => {
        this.map.removeOverlay(item.marker);
      });
    },
    //恢复定位
    tolocation() {
      this.People = this.initialize;
      this.startLocation = this.initialize;
      this.makeInfowindow();
    },
    draggingaaa(a) {
      // console.log("aaaaa");

      //  this.startLocation =this.map.getViewport().center
      console.log("移动结束");
      console.log();
      if (this.process) {
        return;
      }
      this.moveCenterShow = true;
      this.People = this.map.getViewport().center;
      this.dragend(this.map.getViewport().center);
      // this.People = { lng: a.point.lng, lat: a.point.lat };
    },
    dragend(a) {
      console.log("拖拽结束", a);
      if (!this.$store.state.loading) {
        this.shopTypeName = "全部商店";
        // this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/shop/get_fujin_yinshui", {
            params: {
              log: this.map.getViewport().center.lng,
              lat: this.map.getViewport().center.lat
            },
          })
          .then((res) => {
            if (res.data.code == 1) {
              this.shopTypeList = [];
              if (!res.data.data || res.data.data.action.length == 0) {
                this.$store.commit("showLoading", false); //隐藏加载图标
                return;
              }
              res.data.data.action.map((res) => {
                res.show = false;
                this.shopTypeList.push([
                  res.longitude,
                  res.latitude,
                  `<div class="showWindow" style="display: flex;justify-content: space-between;align-items: center;">
                <div class='toshop' shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>` +
                    res.name +
                    `</div>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>营业：` +
                    res.shop_business_hours +
                    `</div>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>位置：` +
                    res.shop_area +
                    `</div>
                </div>
                <div class="toPlace" lat="` +
                    res.latitude +
                    `" lng="` +
                    res.longitude +
                    `" style="padding: 0.2rem 0.3rem;border-radius: 0.1rem;color: white;background-color: #cd160d;">导航</div>
              </div>`,
                  res.name,
                ]);
              });
              var zoom=this.map.getViewport().zoom
              this.makeInfowindow(zoom);
              this.$store.commit("showLoading", false); //隐藏加载图标
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
            }
          });
      }
    },
    //搜索
    SearchShop() {
      if (!this.$store.state.loading) {
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/shop/search_yinshui", {
            params: {
              name: $("#searchShop").val(),
              log: this.$store.state.log,
              lat: this.$store.state.lat,
            },
          })
          .then((res) => {
            if (res.data.code == 1) {
              this.shopTypeList = [];
              if (!res.data.data || res.data.data.action.length == 0) {
                this.$store.commit("showLoading", false); //隐藏加载图标
                this.$store.commit("showMsg", {
                  show: true,
                  type: false,
                  msg: '没有查询到该店铺',
                }); //显示领取失败
                return;
              }
              this.center = {
                lng: res.data.data.action[0].longitude,
                lat: res.data.data.action[0].latitude,
              };
              res.data.data.action.map((res) => {
                res.show = false;
                this.shopTypeList.push([
                  res.longitude,
                  res.latitude,
                  `<div class="showWindow" style="display: flex;justify-content: space-between;align-items: center;">
                <div class='toshop' shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>` +
                    res.name +
                    `</div>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>营业：` +
                    res.shop_business_hours +
                    `</div>
                  <div shopId='` +
                    res.id +
                    `' detail='` +
                    res +
                    `'>位置：` +
                    res.shop_area +
                    `</div>
                </div>
                <div class="toPlace" lat="` +
                    res.latitude +
                    `" lng="` +
                    res.longitude +
                    `" style="padding: 0.2rem 0.3rem;border-radius: 0.1rem;color: white;background-color: #cd160d;">导航</div>
              </div>`,
                  res.name,
                ]);
              });

              this.makeInfowindow();
              this.$store.commit("showLoading", false); //隐藏加载图标
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
            }
          });
      }
    },
    toggle() {
      this.endLocation = {};
      this.process = false;
    },
    toPlace(place) {
      console.log(place);
      // this.endLocation = { lng: 126.6232359800, lat: 45.7213956100 };
      this.process = true;
      this.endLocation = place;
    },
    infoWindowClose(item) {
      item.show = false;
    },
    infoWindowOpen(item) {
      console.log(item);
      item.show = true;
    },
    header({ BMap, map }) {
      console.log(BMap, map);
      this.BMap = BMap;
      this.map = map;
      this.GetShopClassListList();
      // 百度地图API功能
    },
    makeInfowindow(zoom) {
      this.map.clearOverlays();
      this.map.centerAndZoom(
        new BMap.Point(this.People.lng, this.People.lat),
        zoom?zoom:14
      );
      var data_info = this.shopTypeList;
      this.opts = {
        width: 250, // 信息窗口宽度
        height: 80, // 信息窗口高度
        title: "店铺信息", // 信息窗口标题
        enableMessage: true, //设置允许信息窗发送短息
      };

        // 创建小车图标
      var pt = new BMap.Point(this.initialize.lng,this.initialize.lat);
      var myIcon = new BMap.Icon(
        this.centerIMG2,
        new BMap.Size(40, 40)
      );
      var marker2 = new BMap.Marker(pt, {
        icon: myIcon
      }); // 创建标注
      this.map.addOverlay(marker2);
      for (var i = 0; i < data_info.length; i++) {
        var marker = new BMap.Marker(
          new BMap.Point(data_info[i][0], data_info[i][1])
        ); // 创建标注
        var content = data_info[i][2];
        this.map.addOverlay(marker); // 将标注添加到地图中

        //创建 文本标注
        var opts = {
          position: new BMap.Point(data_info[i][0], data_info[i][1]), // 指定文本标注所在的地理位置
          offset: new BMap.Size(-30, 0), //设置文本偏移量
        };
        var label = new BMap.Label(data_info[i][3], opts); // 创建文本标注对象
        label.setStyle({
          color: "#333333",
          fontSize: "12px",
          height: "20px",
          lineHeight: "20px",
          fontFamily: "微软雅黑",
          background: "rgba(0,0,0,0)",
          border: "0px",
        });
        this.map.addOverlay(label);

        this.addClickHandler(content, marker);
      }
    },
    addClickHandler(content, marker) {
      var that = this;
      marker.addEventListener("click", function (e) {
        that.openInfo(content, e);
      });
    },

    openInfo(content, e) {
      var p = e.target;
      var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
      var infoWindow = new BMap.InfoWindow(content, this.opts); // 创建信息窗口对象
      this.map.openInfoWindow(infoWindow, point); //开启信息窗口
      var that = this;
      $(".toPlace").on("click", (e) => {
        var lat = $(e.toElement).attr("lat");
        var lng = $(e.toElement).attr("lng");
        console.log(lat, lng);
        that.toPlace({ lat: lat, lng: lng });
        this.process = true;
      });
    },
    //获取店铺分类
    GetShopClassListList() {
      this.$http
        .get("/api/shop/getShopClassListList", {
          params: {},
        })
        .then((res) => {
          for (var x in res.data) {
            this.ShopClassList.push(res.data[x]);
          }
          this.shopTypeName = this.ShopClassList[0];
          this.GetTypeList();
        });
    },
    clickType(e) {
      this.shopTypeName = e;
      this.GetTypeList();
    },
    //获取分类店铺信息列表
    GetTypeList() {
      if (!this.$store.state.loading) {
        console.log(this.BMap, this.map);
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/shop/list", {
            params: {},
          })
          .then((res) => {
            this.shopTypeList = [];
            res.data.data.action.map((res) => {
              res.show = false;
              if (res.is_water == "是") {
                this.shopTypeList.push([
                  res.longitude,
                  res.latitude,
                  `<div class="showWindow" style="display: flex;justify-content: space-between;align-items: center;">
                    <div>
                      <div>` +
                    res.name +
                    `</div>
                      <div>营业：` +
                    res.shop_business_hours +
                    `</div>
                      <div>位置：` +
                    res.shop_area +
                    `</div>
                    </div>
                    <div class="toPlace" lat="` +
                    res.latitude +
                    `" lng="` +
                    res.longitude +
                    `"  style="padding: 0.2rem 0.3rem;border-radius: 0.1rem;color: white;background-color: #cd160d;">导航</div>
                  </div>`,
                  res.name,
                ]);
              }
            });

            this.makeInfowindow();
            this.$store.commit("showLoading", false); //隐藏加载图标
          });
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.box {
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  position: relative;
}
.searchBox {
  height: 0.8rem;
  width: 6.9rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid #e22319;
  background: white;
  opacity: 0.9;
  border-radius: 0.4rem;
  padding-left: 0.3rem;
  font-size: 0.24rem;
  margin: 0.3rem;
  z-index: 1000;
  position: absolute;
  right: 0;
}
.search {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.searchBox img {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  margin-right: 0.2rem;
}
.searchBox input {
  border: none;
  outline: none;
  -webkit-appearance: none;
}
.clickSearch {
  width: 1.9rem;
  height: 100%;
  background-image: linear-gradient(to right, #e73d35, #bc170f);
  opacity: 1;
  color: white;
  font-size: 0.32rem;
  border-radius: 0.4rem;
  text-align: center;
  line-height: 0.8rem;
}
.LeftBox {
  width: 1.5rem;
}
.LeftBox div {
  background-color: #f7f5f6;
  font-size: 0.26rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
}
.clickType {
  background-color: white !important;
}
#Map {
  width: 100vw !important;
  height: 100vh !important;
  overflow: hidden;
  padding-bottom: 1rem;
}
#Map > div:nth-child(1) {
  width: 6.5rem !important;
  height: 100vh !important;
}
.btn {
  width: 1.5rem;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  background: cornflowerblue;
  color: white;
   margin-top: 1.2rem;
}
.showWindow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.navigation {
  height: 100%;
  padding-right: 0.3rem;
}
.locationImg {
  position: absolute;
  right: 0.5rem;
  bottom: 1.5rem;
  width: 0.7rem;
  height: 0.7rem;
  background: white;
  border-radius: 0.1rem;
  border: 1px solid #e5e5e5;
  box-shadow: 0px 0px 5px #e5e5e5;
  z-index: 100;
  padding: 0.1rem;
}
.locationImg > img {
  width: 100%;
  height: 100%;
}
.moveCenter {
  position: fixed;
  left: 50%;
  top: 50%;
  top: 50%;
  margin-top: -0.75rem;
  margin-left: -0.28rem;
}
.moveCenter > img {
  width: 0.4rem;
  height: 0.4rem;
}
</style>

